import { Children, FC, PropsWithChildren } from 'react';

import { ICarouselFramer } from './interfaces';
import DragSlider from './DragSlider';
import Indicator from 'components/indicator';
import { useCarouselFramer } from './carouselFramer.hooks';
import { IndicatorsList } from './carouselFramer.styles';

const CarouselFramer: FC<PropsWithChildren<ICarouselFramer>> = ({
  children,
  margin,
  childRef,
  bounceStiffness = 100,
  bounceDamping = 5,
}) => {
  const { activeSlide, setActiveSlide } = useCarouselFramer();

  return (
    <>
      <DragSlider
        childRef={childRef}
        activeSlide={activeSlide}
        setActiveSlide={setActiveSlide}
        margin={margin}
        bounceStiffness={bounceStiffness}
        bounceDamping={bounceDamping}
      >
        {children}
      </DragSlider>
      <IndicatorsList>
        {Children.map(children, (child, i) => (
          <Indicator
            onClickHandler={() => setActiveSlide(i)}
            isSelected={activeSlide === i}
            index={i}
            label={i.toString()}
          />
        ))}
      </IndicatorsList>
    </>
  );
};

export { CarouselFramer };
